"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../utils/constants");
var _Stopwatch = _interopRequireDefault(require("../common/Stopwatch/Stopwatch"));
var _types = require("../../utils/types");
var _globalComponentsLibrary = require("global-components-library");
var _reactstrap = require("reactstrap");
var _reactI18next = require("react-i18next");
require("./WrapUp.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var WrapUp = function WrapUp(_ref) {
  var onSelect = _ref.onSelect,
    dispositions = _ref.dispositions,
    show = _ref.show,
    toggle = _ref.toggle,
    acdId = _ref.acdId,
    conversationId = _ref.conversationId,
    type = _ref.type,
    closeModal = _ref.closeModal,
    _ref$time = _ref.time,
    time = _ref$time === void 0 ? 60000 : _ref$time,
    onFinish = _ref.onFinish;
  var _useTranslation = (0, _reactI18next.useTranslation)(['wrapup']),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    disposition = _useState2[0],
    setDisposition = _useState2[1];
  var _useState3 = (0, _react.useState)(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    subDisposition = _useState4[0],
    setSubDisposition = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    timeOnWrapUp = _useState6[0],
    setTimeOnWrapUp = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    disabled = _useState8[0],
    setDisable = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    onCloseOrTimeOut = _useState10[0],
    setOnCloseOrTimeOut = _useState10[1];
  var counterTimeOnWrapUp = null;
  var onSend = function onSend(action) {
    if (action === 'send') {
      if (disposition === undefined) {
        setDisposition(dispositions[0]);
      }
      setDisable(true);
      select();
      setDisposition(undefined);
      setSubDisposition(undefined);
      setTimeOnWrapUp(0);
      if (closeModal) {
        onToggle();
        setTimeout(function () {
          onFinish();
        }, 500);
      }
    } else {
      setOnCloseOrTimeOut(true);
      onToggle();
    }
  };
  (0, _react.useEffect)(function () {
    if (dispositions && type === _constants.TABS.MAIL) {
      dispositions.map(function (option) {
        if (option.endConversation) {
          option.icon = 'selected';
          option.tooltiptext = t('endconversation');
        }
      });
    }
  }, [dispositions]);
  (0, _react.useEffect)(function () {
    if (disposition && disposition.subDispositions && type === _constants.TABS.MAIL) {
      disposition.subDispositions.map(function (option) {
        if (option.endConversation) {
          option.icon = 'selected';
          option.tooltiptext = t('endconversation');
        }
      });
    }
  }, [disposition]);
  var select = function select() {
    if (onCloseOrTimeOut) {
      onSelect({
        acdId: acdId,
        conversationId: conversationId,
        type: _constants.MEDIATYPE[type],
        disposition: 0,
        subDisposition: 0,
        wrapUp: timeOnWrapUp,
        closeModal: closeModal
      });
      return;
    }
    if (disposition && !subDisposition) {
      onSelect({
        acdId: acdId,
        conversationId: conversationId,
        type: _constants.MEDIATYPE[type],
        disposition: disposition.id,
        subDisposition: 0,
        wrapUp: timeOnWrapUp,
        closeModal: closeModal
      });
    }
    if (disposition && subDisposition) {
      onSelect({
        acdId: acdId,
        conversationId: conversationId,
        type: _constants.MEDIATYPE[type],
        disposition: disposition.id,
        subDisposition: subDisposition.id,
        wrapUp: timeOnWrapUp,
        closeModal: closeModal
      });
    }
    if (!disposition) {
      onSelect({
        acdId: acdId,
        conversationId: conversationId,
        type: _constants.MEDIATYPE[type],
        disposition: 0,
        subDisposition: 0,
        wrapUp: timeOnWrapUp,
        closeModal: closeModal
      });
    }
  };
  (0, _react.useEffect)(function () {
    if (show === true) {
      counterTimeOnWrapUp = setInterval(function () {
        setTimeOnWrapUp(function (timeOnWrapUp) {
          return timeOnWrapUp + 1;
        });
      }, 1000);
    }
    return function () {
      clearInterval(counterTimeOnWrapUp);
    };
  }, [show]);
  (0, _react.useEffect)(function () {
    if (disposition === undefined) setDisposition(undefined);
    setSubDisposition(undefined);
  }, [disposition]);
  var onToggle = function onToggle() {
    toggle();
    setDisable(false);
  };
  (0, _react.useEffect)(function () {
    if (onCloseOrTimeOut) {
      if (!disabled) select();
      setDisposition(undefined);
      setSubDisposition(undefined);
      setTimeOnWrapUp(0);
      setOnCloseOrTimeOut(false);
      setTimeout(function () {
        onFinish();
      }, 500);
    }
  }, [onCloseOrTimeOut]);
  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Modal, {
    isOpen: show,
    toggle: toggle,
    className: "uin-wrapup ".concat(dispositions ? '' : 'small'),
    centered: true,
    backdrop: "static"
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalHeader, {
    className: "uin-wrapup-header ".concat(dispositions ? '' : 'small'),
    toggle: closeModal ? function () {
      return onSend('close');
    } : undefined
  }, t('title')), /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalBody, {
    className: "uin-wrapup-body ".concat(dispositions ? '' : 'small')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-wrapup-countdown",
    id: "uinw-countdown"
  }, /*#__PURE__*/_react["default"].createElement(_Stopwatch["default"], {
    countdown: true,
    initialTime: time,
    countdownAction: function countdownAction() {
      setOnCloseOrTimeOut(true);
      setTimeout(function () {
        onToggle();
      }, 10);
    },
    viewHours: true
  })), dispositions && /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-wrapup-options"
  }, /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.SearchSelection, {
    className: "uin-wrapup-dopdown",
    options: dispositions,
    placeholder: t('placeholder'),
    onSelected: setDisposition,
    filterBy: 'text',
    defaultIndex: 0,
    disabled: disabled,
    ignoreCase: true,
    swapStyles: true
  })), disposition && disposition.subDispositions && /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-wrapup-sub-options"
  }, /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.SearchSelection, {
    className: "uin-wrapup-dopdown",
    options: disposition.subDispositions,
    placeholder: t('placeholderSub'),
    onSelected: setSubDisposition,
    filterBy: 'text',
    defaultIndex: 0,
    disabled: disabled,
    ignoreCase: true,
    swapStyles: true
  }))), /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalFooter, {
    className: "uin-wrapup-footer ".concat(dispositions ? '' : 'small')
  }, /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Button, {
    color: "primary",
    onClick: function onClick() {
      return onSend('send');
    },
    disabled: disabled
  }, disposition || !closeModal ? t('select') : t('end'))));
};
WrapUp.propTypes = {
  show: _propTypes["default"].bool.isRequired,
  time: _propTypes["default"].number.isRequired,
  toggle: _propTypes["default"].func.isRequired,
  onFinish: _propTypes["default"].func.isRequired,
  dispositions: _propTypes["default"].arrayOf(_types.dispositionType).isRequired
};
var _default = exports["default"] = WrapUp;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/WrapUp/WrapUp.js
// module id = 1429
// module chunks = 0